import React, { useState, useReducer } from 'react';

import { Auth } from 'aws-amplify';

import DialogDefault from '../components/common/DialogDefault';
import FormLogin from '../components/forms/FormLogin';
import FormRecoverPassword from '../components/forms/FormRecoverPassword';

function confirmReducer(state, action) {
	switch (action.type) {
		case 'field': {
			return {
				...state,
				[action.fieldName]: action.payload,
			};
		}
		case 'login': {
			return {
				...state,
				error: '',
			};
		}
		case 'success': {
			return {
				...state,
				message: action.message,
				checked: true,
			};
		}
		case 'error': {
			return {
				...state,
				message: action.error,
				checked: true,
			};
		}
		default:
			return state;
	}
}

const initialState = {
	message: '',
	checked: false,
};

const PageLogin = ({
	confirmCode,
	userName,
	openModal,
	closeModal,
	openRegisterModal,
}) => {
	const [changePasswordScreen, setChangePasswordScreen] = useState(false);
	const [state, dispatch] = useReducer(confirmReducer, initialState);
	const { message, checked } = state;

	const confirmedCode = async () => {
		if (!checked) {
			if (typeof userName === 'string' && typeof confirmCode === 'string') {
				try {
					await Auth.confirmSignUp(userName, confirmCode);
					dispatch({
						type: 'success',
						message: 'Sie haben sich erfolgreich registriert',
					});
				} catch (error) {
					const confirmMessage =
						'User cannot be confirmed. Current status is CONFIRMED';
					// prettier-ignore
					// eslint-disable-next-line no-unused-expressions
					error.message === confirmMessage
						? dispatch({
							type: 'error',
							error: 'Die Registierung wurde bereits abgeschlossen.',
						  })
						: dispatch({ type: 'error', error: error.message });
				}
			} else {
				dispatch({ type: 'success', message: '' });
			}
		}
	};

	confirmedCode();

	const messageBox = (msg) => {
		if (msg !== '') {
			return (
				<div
					style={{
						backgroundColor: '#007484',
						height: '40px',
						paddingTop: '10px',
						paddingLeft: '10px',
						color: 'white',
					}}
				>
					{' '}
					{message}{' '}
				</div>
			);
		}
	};

	const handleClose = () => {
		setChangePasswordScreen(!changePasswordScreen);
	};

	return (
		<>
			<DialogDefault
				headline="Anmelden"
				openModal={openModal}
				closeModal={closeModal}
				showButtons={false}
			>
				{messageBox(message)}
				<FormLogin
					closeLoginModal={closeModal}
					openRegisterModal={openRegisterModal}
					openChangePasswordScreen={() =>
						setChangePasswordScreen(!changePasswordScreen)
					}
				/>
			</DialogDefault>
			<DialogDefault
				headline="Passwort wiederherstellen"
				openModal={changePasswordScreen}
				closeModal={handleClose}
				showButtons={false}
			>
				<FormRecoverPassword close={handleClose} />
			</DialogDefault>
		</>
	);
};

export default PageLogin;
